import React from "react";
import LoginComp from "../../components/Frontend/LoginComp";
import HomePageLayout from "../../layouts/HomepageLayout";
import "../../styles/Frontend/pages.scss";

const Login = () => {
  return (
    <HomePageLayout>
      <div className="auth">
        <div className=" inner">
          <div className="info">
            <div className="info-text">
              <h1>SYSTEM LOGIN</h1>
              <hr />
              <p>
                Please enter your Email / Password to sign-in to your secured
                account area.
              </p>
            </div>
          </div>
          <div className="form">
            <LoginComp />
          </div>
        </div>
      </div>
    </HomePageLayout>
  );
};

export default Login;
